import script from "./FivePower.vue?vue&type=script&setup=true&lang=js"
export * from "./FivePower.vue?vue&type=script&setup=true&lang=js"

import "./FivePower.vue?vue&type=style&index=0&id=5f67133a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f67133a"]])

export default __exports__